<div class="project-tasks-tab">

    <div class="title">Project Tasks</div>

    <!-- Email Channel Disabled Banner -->
    <div *ngIf="isEmailDisabled" class="alert alert-info margin-bottom-20"
        style="background-color: #d1ecf1; border-color: #bee5eb; color: #0c5460; padding: 12px; border-radius: 4px;">
        <i class="fa fa-info-circle"></i> Email channel has been disabled.
    </div>

    <form [formGroup]="formGroup">

        <!-- Task Updates -->
        <div class="row notify-group">

            <div class="task-icon-container col-md-1">
                <i class="fa-regular fa-bell fa-2x"></i>
            </div>

            <div class="col-md-10">

                <div class="row">
                    <div class="col-md-12">
                        <div class="font-bold margin-top-5">Project Task Updates</div>
                        <div class="margin-top-5">Notifications about when teammates add, modify, or remove project tasks.</div>
                    </div>
                </div>
            </div>

            <div class="col-md-1">
                <dx-switch formControlName="projectTaskUpdatesSwitch" [value]="true" [width]="50" [switchedOnText]="''"
                    [switchedOffText]="''"
                    (onValueChanged)="onTaskUpdatesSwitchChanged($event)">
                </dx-switch>
            </div>
        </div>
    </form>
</div>